import React from 'react';

type MessageIconProps = {
  className?: string;
  style?: React.CSSProperties;
};

export function MessageIcon({ className = '', style }: MessageIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      className={className}
      style={style}
    >
      <path
        d="M4.2 13.6C4.1207 13.6 4.04102 13.5844 3.96523 13.5523C3.74374 13.4578 3.6 13.2406 3.6 13V10.4H3C1.3457 10.4 0 9.0539 0 7.4V3C0 1.3461 1.3457 0 3 0H11.4C13.0543 0 14.4 1.3461 14.4 3V7.4C14.4 9.0539 13.0543 10.4 11.4 10.4H7.76562L4.61602 13.432C4.50195 13.5422 4.35234 13.6 4.2 13.6ZM3 1.2C2.00742 1.2 1.2 2.00782 1.2 3V7.4C1.2 8.39218 2.00742 9.2 3 9.2H4.2C4.53125 9.2 4.8 9.46875 4.8 9.8V11.5898L7.10782 9.36797C7.21954 9.26015 7.36875 9.2 7.52383 9.2H11.4C12.3926 9.2 13.2 8.39218 13.2 7.4V3C13.2 2.00782 12.3926 1.2 11.4 1.2H3Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default MessageIcon;
